export const select2FormStatus = {
    placeholder: "",
    allowClear: false,
    dropdownCssClass: 'status-operational-dropdown-selector'
}